export const SET_CURRENT_USER = 'auth/setCurrentUser';
export const GET_USER_INFO = 'auth/getUserInfo';
export const LOGOUT_USER = 'auth/LOGOUT_USER';
export const GET_SCHOOL_BY_ID = 'auth/GET_SCHOOL_BY_ID';
